module.exports = __webpack_public_path__ + "45ab10488cf1f7074ddc420a195ce60e.xls";